import { useEffect, useState } from "react";

const YesNo = ({value=false,setValue,dataKey=""}) => {

    const [Yes, setYes] = useState(value.toString() === "true"?true:false);

    useEffect(()=>{
        setValue(dataKey,Yes) ;
    },[Yes,dataKey])

    useEffect(()=>{
        setYes(value.toString() === "true"?true:false);
    },[value])

    function setYesNoValue(key, value) {
        setFormState((fs) => ({ ...fs, [key]: value }));
    }

    return ( 
        <div className="d-flex align-items-center">
            <label className="d-flex align-items-center">
                <input onChange={(e)=>setYes(true)} className="form-check-input" type="radio" name="" id="yesField" checked={Yes}/>
                <span className="ms-2">Yes</span>
            </label>
            <label className="ms-3 d-flex align-items-center">
                <input onChange={(e)=>setYes(false)} className="form-check-input" type="radio" name="" id="yesField" checked={!Yes }/>
                <span className="ms-2">No</span>
            </label>
        </div> 
    );
}
 
export default YesNo;